import { render, staticRenderFns } from "./pcHome.vue?vue&type=template&id=7fde3b80&scoped=true&"
import script from "./pcHome.vue?vue&type=script&lang=js&"
export * from "./pcHome.vue?vue&type=script&lang=js&"
import style0 from "./pcHome.vue?vue&type=style&index=0&id=7fde3b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde3b80",
  null
  
)

export default component.exports